/**
 * YUL On Tap - Centralized Asset Configuration
 * 
 * All uploaded assets are served from the Emergent customer-assets CDN.
 * When a custom CDN (assets.yulontap.com) is configured in the future,
 * set REACT_APP_ASSET_BASE_URL in .env.production to override.
 */

const ASSET_CDN = process.env.REACT_APP_ASSET_BASE_URL
  || 'https://customer-assets.emergentagent.com/job_tap-platform-build/artifacts';

export const ASSETS = {
  LOGO: '/yulontap-logo.png',
  LOGO_EMBLEM: '/yulontap-emblem.png',
  TAPELLIGENCE_LOGO: '/tapelligence-logo.png',
  DASHBOARD_MAIN: `https://customer-assets.emergentagent.com/job_tap-platform-build/artifacts/tanmimww_54EFA0F4-9FB8-43C7-ABC3-01D291736B69.png`,
  DASHBOARD_SHIFT_INSIGHTS: `${ASSET_CDN}/j6tapfv5_E0AAD7DD-E952-4FB7-B544-02EE0BB4AC48.png`,
  TAP_ENGINE_CARDS: `${ASSET_CDN}/a7yuq8oe_16CA4B8A-8B00-4862-BAE4-D7973D0048B7.png`,
  PHYSICAL_TAP: `https://customer-assets.emergentagent.com/job_tap-platform-build/artifacts/5d2vnvpo_5171BFAB-76A2-40DD-99C6-B3E406B8D028.png`,
  DELFRISCOS_PHONE: `${ASSET_CDN}/p442km8a_C8910E69-C759-4818-90C5-7502B8B3F6DC.png`,
  DASHBOARD_ROI: `${ASSET_CDN}/vwihuq4j_82D0B57F-34D5-48B7-8DCA-82165C8D309A.png`,
  PORTAL_LOGIN: `${ASSET_CDN}/25fx3fxp_IMG_3145.jpeg`,
  REVIEW_SHIELD_POSITIVE: `${ASSET_CDN}/645fmzfo_A4CC4D73-D366-4F27-B309-2ABD641CD139.png`,
  REVIEW_SHIELD_NEGATIVE: `${ASSET_CDN}/3hgg4j6s_DA0C71CE-C32A-4463-BDBC-75A3F7957968.png`,
  GLOBAL_REVIEW_DASHBOARD: `https://customer-assets.emergentagent.com/job_tap-platform-build/artifacts/p2pnx0pj_54EFA0F4-9FB8-43C7-ABC3-01D291736B69.png`,
};

export const STOCK_IMAGES = {
  HERO_RESTAURANT: 'https://images.unsplash.com/photo-1632758750354-39ab3025fce5?auto=format&fit=crop&w=2000&q=80',
  RESTAURANT_INTERIOR: 'https://images.unsplash.com/photo-1767277680127-dc94441d576c?auto=format&fit=crop&w=800&q=80',
  FINE_DINING: 'https://images.unsplash.com/photo-1560145725-8cbf9768b73a?auto=format&fit=crop&w=800&q=80',
  FINE_DINING_TABLE: 'https://images.unsplash.com/photo-1761095596996-d3553cd1721c?auto=format&fit=crop&w=800&q=80',
  BAR_ELEGANT: 'https://images.unsplash.com/photo-1762086931967-eadf80b78873?auto=format&fit=crop&w=2000&q=80',
  TAP_ENGINE: 'https://images.unsplash.com/photo-1726661025461-5635b785ec23?auto=format&fit=crop&w=800&q=80',
  RESTAURANT_CONTACT: 'https://images.unsplash.com/photo-1769985840806-a3d8e225e182?auto=format&fit=crop&w=800&q=80',
  RESTAURANT_DARK: 'https://images.unsplash.com/photo-1684952058836-75bf423ebf4e?auto=format&fit=crop&w=800&q=80',
};

export default ASSETS;
